import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import MumbleClient from 'mumble-client';
import Promise from 'promise';
import EventEmitter from 'events';
import { Writable, PassThrough } from 'stream';
import toArrayBuffer from 'to-arraybuffer';
import ByteBuffer from 'bytebuffer';
import Worker from './worker';
/**
 * Creates proxy MumbleClients to a real ones running on a web worker.
 * Only stuff which we need in mumble-web is proxied, i.e. this is not a generic solution.
 */

var WorkerBasedMumbleConnector = /*#__PURE__*/function () {
  function WorkerBasedMumbleConnector() {
    _classCallCheck(this, WorkerBasedMumbleConnector);

    this._reqId = 1;
    this._requests = {};
    this._clients = {};
    this._nextVoiceId = 1;
    this._voiceStreams = {};
  }

  _createClass(WorkerBasedMumbleConnector, [{
    key: "setSampleRate",
    value: function setSampleRate(sampleRate) {
      this._postMessage({
        method: '_init',
        sampleRate: sampleRate
      });
    }
  }, {
    key: "_postMessage",
    value: function _postMessage(msg, transfer) {
      if (!this._worker) {
        this._worker = new Worker();

        this._worker.addEventListener('message', this._onMessage.bind(this));
      }

      try {
        this._worker.postMessage(msg, transfer);
      } catch (err) {
        console.error('Failed to postMessage', msg);
        throw err;
      }
    }
  }, {
    key: "_call",
    value: function _call(id, method, payload, transfer) {
      var reqId = this._reqId++;
      console.debug(method, id, payload);

      this._postMessage({
        clientId: id.client,
        channelId: id.channel,
        userId: id.user,
        method: method,
        reqId: reqId,
        payload: payload
      }, transfer);

      return reqId;
    }
  }, {
    key: "_query",
    value: function _query(id, method, payload, transfer) {
      var _this = this;

      var reqId = this._call(id, method, payload, transfer);

      return new Promise(function (resolve, reject) {
        _this._requests[reqId] = [resolve, reject];
      });
    }
  }, {
    key: "_addCall",
    value: function _addCall(proxy, name, id) {
      var self = this;

      proxy[name] = function () {
        self._call(id, name, Array.from(arguments));
      };
    }
  }, {
    key: "connect",
    value: function connect(host, args) {
      var _this2 = this;

      return this._query({}, '_connect', {
        host: host,
        args: args
      }).then(function (id) {
        return _this2._client(id);
      });
    }
  }, {
    key: "_client",
    value: function _client(id) {
      var client = this._clients[id];

      if (!client) {
        client = new WorkerBasedMumbleClient(this, id);
        this._clients[id] = client;
      }

      return client;
    }
  }, {
    key: "_onMessage",
    value: function _onMessage(ev) {
      var data = ev.data;

      if (data.reqId != null) {
        console.debug(data);
        var reqId = data.reqId,
            result = data.result,
            error = data.error;

        var _this$_requests$reqId = _slicedToArray(this._requests[reqId], 2),
            resolve = _this$_requests$reqId[0],
            reject = _this$_requests$reqId[1];

        delete this._requests[reqId];

        if (result) {
          resolve(result);
        } else {
          reject(error);
        }
      } else if (data.clientId != null) {
        console.debug(data);

        var client = this._client(data.clientId);

        var target;

        if (data.userId != null) {
          target = client._user(data.userId);
        } else if (data.channelId != null) {
          target = client._channel(data.channelId);
        } else {
          target = client;
        }

        if (data.event) {
          target._dispatchEvent(data.event, data.value);
        } else if (data.prop) {
          target._setProp(data.prop, data.value);
        }
      } else if (data.voiceId != null) {
        var stream = this._voiceStreams[data.voiceId];
        var buffer = data.buffer;

        if (buffer) {
          stream.write({
            target: data.target,
            buffer: Buffer.from(buffer)
          });
        } else {
          delete this._voiceStreams[data.voiceId];
          stream.end();
        }
      }
    }
  }]);

  return WorkerBasedMumbleConnector;
}();

export var WorkerBasedMumbleClient = /*#__PURE__*/function (_EventEmitter) {
  _inherits(WorkerBasedMumbleClient, _EventEmitter);

  var _super = _createSuper(WorkerBasedMumbleClient);

  function WorkerBasedMumbleClient(connector, clientId) {
    var _this3;

    _classCallCheck(this, WorkerBasedMumbleClient);

    _this3 = _super.call(this);
    _this3._connector = connector;
    _this3._id = clientId;
    _this3._users = {};
    _this3._channels = {};
    var id = {
      client: clientId
    };

    connector._addCall(_assertThisInitialized(_this3), 'setSelfDeaf', id);

    connector._addCall(_assertThisInitialized(_this3), 'setSelfMute', id);

    connector._addCall(_assertThisInitialized(_this3), 'setSelfTexture', id);

    connector._addCall(_assertThisInitialized(_this3), 'setAudioQuality', id);

    connector._addCall(_assertThisInitialized(_this3), '_send', id);

    connector._addCall(_assertThisInitialized(_this3), 'disconnect', id);

    var _disconnect = _this3.disconnect;

    _this3.disconnect = function () {
      _disconnect.apply(_assertThisInitialized(_this3));

      delete connector._clients[id];
    };

    connector._addCall(_assertThisInitialized(_this3), 'createVoiceStream', id);

    var _createVoiceStream = _this3.createVoiceStream;

    _this3.createVoiceStream = function () {
      var voiceId = connector._nextVoiceId++;
      var args = Array.from(arguments);
      args.unshift(voiceId);

      _createVoiceStream.apply(this, args);

      return new Writable({
        write: function write(chunk, encoding, callback) {
          chunk = toArrayBuffer(chunk);

          connector._postMessage({
            voiceId: voiceId,
            chunk: chunk
          });

          callback();
        },
        "final": function final(callback) {
          connector._postMessage({
            voiceId: voiceId
          });

          callback();
        }
      });
    }; // Dummy client used for bandwidth calculations


    _this3._dummyClient = new MumbleClient({
      username: 'dummy'
    });

    var defineDummyMethod = function defineDummyMethod(name) {
      _this3[name] = function () {
        return this._dummyClient[name].apply(this._dummyClient, arguments);
      };
    };

    defineDummyMethod('getMaxBitrate');
    defineDummyMethod('getActualBitrate');
    var _setAudioQuality = _this3.setAudioQuality;

    _this3.setAudioQuality = function () {
      this._dummyClient.setAudioQuality.apply(this._dummyClient, arguments);

      _setAudioQuality.apply(this, arguments);
    };

    return _this3;
  }

  _createClass(WorkerBasedMumbleClient, [{
    key: "_user",
    value: function _user(id) {
      var user = this._users[id];

      if (!user) {
        user = new WorkerBasedMumbleUser(this._connector, this, id);
        this._users[id] = user;
      }

      return user;
    }
  }, {
    key: "_channel",
    value: function _channel(id) {
      var channel = this._channels[id];

      if (!channel) {
        channel = new WorkerBasedMumbleChannel(this._connector, this, id);
        this._channels[id] = channel;
      }

      return channel;
    }
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(name, args) {
      var _this4 = this;

      if (name === 'newChannel') {
        args[0] = this._channel(args[0]);
      } else if (name === 'newUser') {
        args[0] = this._user(args[0]);
      } else if (name === 'message') {
        args[0] = this._user(args[0]);
        args[2] = args[2].map(function (id) {
          return _this4._user(id);
        });
        args[3] = args[3].map(function (id) {
          return _this4._channel(id);
        });
        args[4] = args[4].map(function (id) {
          return _this4._channel(id);
        });
      }

      args.unshift(name);
      this.emit.apply(this, args);
    }
  }, {
    key: "_setProp",
    value: function _setProp(name, value) {
      if (name === 'root') {
        name = '_rootId';
      }

      if (name === 'self') {
        name = '_selfId';
      }

      if (name === 'maxBandwidth') {
        this._dummyClient.maxBandwidth = value;
      }

      this[name] = value;
    }
  }, {
    key: "root",
    get: function get() {
      return this._channel(this._rootId);
    }
  }, {
    key: "channels",
    get: function get() {
      return Object.values(this._channels);
    }
  }, {
    key: "users",
    get: function get() {
      return Object.values(this._users);
    }
  }, {
    key: "self",
    get: function get() {
      return this._user(this._selfId);
    }
  }]);

  return WorkerBasedMumbleClient;
}(EventEmitter);

var WorkerBasedMumbleChannel = /*#__PURE__*/function (_EventEmitter2) {
  _inherits(WorkerBasedMumbleChannel, _EventEmitter2);

  var _super2 = _createSuper(WorkerBasedMumbleChannel);

  function WorkerBasedMumbleChannel(connector, client, channelId) {
    var _this5;

    _classCallCheck(this, WorkerBasedMumbleChannel);

    _this5 = _super2.call(this);
    _this5._connector = connector;
    _this5._client = client;
    _this5._id = channelId;
    var id = {
      client: client._id,
      channel: channelId
    };

    connector._addCall(_assertThisInitialized(_this5), 'sendMessage', id);

    return _this5;
  }

  _createClass(WorkerBasedMumbleChannel, [{
    key: "_dispatchEvent",
    value: function _dispatchEvent(name, args) {
      var _this6 = this;

      if (name === 'update') {
        var _args = args,
            _args2 = _slicedToArray(_args, 1),
            props = _args2[0];

        Object.entries(props).forEach(function (entry) {
          _this6._setProp(entry[0], entry[1]);
        });

        if (props.parent != null) {
          props.parent = this.parent;
        }

        if (props.links != null) {
          props.links = this.links;
        }

        args = [props];
      } else if (name === 'remove') {
        delete this._client._channels[this._id];
      }

      args.unshift(name);
      this.emit.apply(this, args);
    }
  }, {
    key: "_setProp",
    value: function _setProp(name, value) {
      var _this7 = this;

      if (name === 'parent') {
        name = '_parentId';
      }

      if (name === 'links') {
        value = value.map(function (id) {
          return _this7._client._channel(id);
        });
      }

      this[name] = value;
    }
  }, {
    key: "parent",
    get: function get() {
      if (this._parentId != null) {
        return this._client._channel(this._parentId);
      }
    }
  }, {
    key: "children",
    get: function get() {
      var _this8 = this;

      return Object.values(this._client._channels).filter(function (it) {
        return it.parent === _this8;
      });
    }
  }]);

  return WorkerBasedMumbleChannel;
}(EventEmitter);

var WorkerBasedMumbleUser = /*#__PURE__*/function (_EventEmitter3) {
  _inherits(WorkerBasedMumbleUser, _EventEmitter3);

  var _super3 = _createSuper(WorkerBasedMumbleUser);

  function WorkerBasedMumbleUser(connector, client, userId) {
    var _this9;

    _classCallCheck(this, WorkerBasedMumbleUser);

    _this9 = _super3.call(this);
    _this9._connector = connector;
    _this9._client = client;
    _this9._id = userId;
    var id = {
      client: client._id,
      user: userId
    };

    connector._addCall(_assertThisInitialized(_this9), 'requestTexture', id);

    connector._addCall(_assertThisInitialized(_this9), 'clearTexture', id);

    connector._addCall(_assertThisInitialized(_this9), 'setMute', id);

    connector._addCall(_assertThisInitialized(_this9), 'setDeaf', id);

    connector._addCall(_assertThisInitialized(_this9), 'sendMessage', id);

    _this9.setChannel = function (channel) {
      connector._call(id, 'setChannel', channel._id);
    };

    return _this9;
  }

  _createClass(WorkerBasedMumbleUser, [{
    key: "_dispatchEvent",
    value: function _dispatchEvent(name, args) {
      var _this10 = this;

      if (name === 'update') {
        var _args3 = args,
            _args4 = _slicedToArray(_args3, 2),
            actor = _args4[0],
            props = _args4[1];

        Object.entries(props).forEach(function (entry) {
          _this10._setProp(entry[0], entry[1]);
        });

        if (props.channel != null) {
          props.channel = this.channel;
        }

        if (props.texture != null) {
          props.texture = this.texture;
        }

        args = [this._client._user(actor), props];
      } else if (name === 'voice') {
        var _args5 = args,
            _args6 = _slicedToArray(_args5, 2),
            id = _args6[0],
            target = _args6[1];

        var stream = new PassThrough({
          objectMode: true
        });
        this._connector._voiceStreams[id] = stream;
        stream.target = target;
        args = [stream];
      } else if (name === 'remove') {
        delete this._client._users[this._id];
      }

      args.unshift(name);
      this.emit.apply(this, args);
    }
  }, {
    key: "_setProp",
    value: function _setProp(name, value) {
      if (name === 'channel') {
        name = '_channelId';
      }

      if (name === 'texture') {
        if (value) {
          var buf = ByteBuffer.wrap(value.buffer);
          buf.offset = value.offset;
          buf.limit = value.limit;
          value = buf;
        }
      }

      this[name] = value;
    }
  }, {
    key: "channel",
    get: function get() {
      return this._client._channels[this._channelId];
    }
  }]);

  return WorkerBasedMumbleUser;
}(EventEmitter);

export default WorkerBasedMumbleConnector;